<template>
  <step :number="1">
    <template v-slot:head>
      {{ i18n.step_1 }}
    </template>

    <template v-slot:content>
      <div class="p-3 p-md-4">
        <div class="box-select__option" v-for="(box, id) in boxSpecifications" :key="id">
          <input
            type="radio"
            name="specification"
            :id="`specification-${id}`"
            :checked="activeBoxSpecificationId === id"
            @change="(event) => onSpecificationSelect(event, id)"
          >
          <label class="box-select__option-label" :for="`specification-${id}`">
            <div class="box-select__option-image">
              <img
                :src="`/front_assets/img/boxes/${box.image}`"
                :alt="`${i18n.illustration_of} ${box.title}`"
                width="669"
                height="669"
              />
            </div>
            <span>
              {{ box.title }}
            </span>
          </label>
        </div>
      </div>
    </template>
  </step>
</template>

<script>
import { mapGetters } from 'vuex';
import Step from './Step';

export default {
  components: {
    Step,
  },

  computed: {
    ...mapGetters([
      'boxSpecifications',
      'activeBoxSpecification',
      'activeBoxSpecificationId',
    ]),
  },

  methods: {
    onSpecificationSelect(event, id) {
      this.$store.dispatch('setActiveBoxSpecification', id);
    },
  },
};
</script>

<style scoped>
.box-select__option {
  overflow: hidden;
  position: relative;
  width: 8.5rem;
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.box-select__option input {
  position: absolute;
  left: -9999px;
  opacity: 0;
}

.box-select__option-image {
  padding-bottom: 100%;
  position: relative;
  margin-bottom: .75rem;
}

.box-select__option img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  height: auto;
  display: block;
  transform: translate(-50%, -50%);
}

input + .box-select__option-label {
  padding-left: 0;
}

.box-select__option-label {
  width: 100%;
}

.box-select__option-label:before,
.box-select__option-label:after {
  display: none;
}

.box-select__option-label span {
  position: relative;
  display: inline-block;
  padding-left: 2em;
}

.box-select__option-label span:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0.7em;
  margin-top: -10px;
  border: 1px solid #b7b1a8;
  border-radius: 50%;
  background: #fff;
  width: 20px;
  height: 20px;
  margin-bottom: -4px;
}

.box-select__option-label span:after {
  content: '';
  display: block;
  position: absolute;
  top: 0.7em;
  left: 4px;
  visibility: hidden;
  opacity: 0;
  z-index: 1;
  margin-top: -6px;
  border-radius: 50%;
  background: #555;
  width: 12px;
  height: 12px;
}

input:checked + .box-select__option-label span:after {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 399px) {
  .box-select__option {
    width: calc(48% - 1rem);
  }

  .box-select__option-image {
    width: 5rem;
    height: 5rem;
    padding-bottom: 0;
  }
}
</style>
